export const environment = {
  production: false,
  ApiUrl: "https://g6b1scl6sf.execute-api.eu-north-1.amazonaws.com/stage",
  WebSocketUrl: "wss://v8wxd6xy3h.execute-api.eu-north-1.amazonaws.com/stage/",
  CognitoUserPoolId: "eu-north-1_Z5Zw2c9F7",
  CognitoAppClientId: "31ef6n6v49j5k8beerp1vf238j",
  BucketName: "farsk-stage-images",
  Region: "eu-north-1",
};
